import './HowItWorks.css'
import location from '../../assets/svg/location.svg'
import clock from '../../assets/svg/clock.svg'
import howItWorkBg from '../../assets/images/howItWorkBg.png'
import howItWorkBgGroup from '../../assets/images/howItWorkBgGroup.png'
function HowItWorks() {
  return (
    <div className='HowItWorks'>
      <div className='text-content'>
        <div className='theme-heading-text'>How It Works: <br />
          Location Verification for Accurate Attendance</div>
        <p className='theme-text-small-16'>BrainyClock employs a robust geofence system to ensure precise and secure attendance tracking.</p>
        <div className='step-container'>
          <div className="step">
            <div className='d-flex gap-24 align-items-center'>
              <div className='icon'><img src={location} alt="location" /></div>
              <div className='d-flex gap-8 flex-column'>
                <div className='theme-heading-text-16'>Step 1</div>
                <div className='theme-heading-text-24'>Geofencing Setup</div>
              </div>
            </div>
            <div className='d-flex gap-24 align-items-center'>
              <div style={{ minWidth: '40px' }}></div>
              <div className='theme-text-small-16'>
                Administrators define virtual boundaries around specific work sites using the BrainyClock web portal.
              </div>
            </div>
          </div>

          <div className="step">
            <div className='d-flex gap-24 align-items-center'>
              <div className='icon'><img src={clock} alt="clock" /></div>
              <div className='d-flex gap-8 flex-column'>
                <div className='theme-heading-text-16'>Step 2</div>
                <div className='theme-heading-text-24'>Clock-In Process</div>
              </div>
            </div>
            <div className='d-flex gap-24 align-items-center'>
              <div style={{ minWidth: '40px' }}></div>
              <div className='theme-text-small-16'>
                Employees arrive within the geofence; the system verifies their location within the geofence before completing the clock-in.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='img-content'>
        <img src={howItWorkBgGroup} alt="howItWorkBgGroup" className='howItWorkBgGroup' />
      </div>
      <div className='HowItWorks-bg d-lg-block d-none'><img src={howItWorkBg} alt="howItWorkBg" /></div>
    </div>
  )
}

export default HowItWorks
